
import React from 'react';

export const ChatBubbleLeftEllipsisIcon: React.FC<{ className?: string }> = ({ className }) => (
    <span className={`material-symbols-outlined ${className}`}>
      chat
    </span>
);